import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {SirenSMSConfig} from "./useGetSirenSMSConfig";
import {useEvents} from "../../../lib/useEvents";

export type SirenSMSConfigInput = {
    clientID?: string;
    departmentID?: string;
    sirenRecipientPortalURL: string;
    introductoryMessage: string;
    smsOptInExemptions: string[];
};

export function useUpsertSirenSMSConfig() {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const {emit} = useEvents();

    const save = useCallback(async (input: SirenSMSConfigInput): Promise<SirenSMSConfig> => {
        setSaving(true);
        setError(null);
        try {
            const res = await platformAPI.post<SirenSMSConfig>("api/siren/sms-config", input);
            emit("siren:smsConfig:changed", {clientID: input.clientID, departmentID: input.departmentID || undefined});
            return res.data;
        } catch {
            setError("Failed to save SMS config");
            throw new Error("save failed");
        } finally {
            setSaving(false);
        }
    }, [emit]);

    return {save, saving, error};
}
